import React, { useState, useContext } from "react";
import { register as registerRequest } from "../../services/AuthServices";
import { useLocation, useNavigate } from "react-router-dom";
import styles from './styles/LoginRegister.module.css';
import GoogleSignInButton from './GoogleSignInButton';
import TurnstileWidget, { TURNSTILE_ENABLED } from './TurnstileWidget';
import HoneypotField from './HoneypotField';
import AuthContext from "../../context/AuthContext";

function Register({ setShowModal, setAuthModalState, acceptInvite, setAcceptInvite }) {
    const [email, setEmail] = useState("");
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [passwordVerify, setPasswordVerify] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [website, setWebsite] = useState(""); // honeypot; stays empty for humans
    // Sign-up always needs a CAPTCHA: a new account has no history to score.
    const [captchaToken, setCaptchaToken] = useState(null);
    const [captchaResetKey, setCaptchaResetKey] = useState(0);
    const location = useLocation();
    const navigate = useNavigate(); 
    const { getLoggedIn } = useContext(AuthContext); 

    async function register(e) {
        e.preventDefault();
        setErrorMessage(""); 
        try {
            const registerData = {
                email: email.trim(),
                username: username.trim(),
                password,
                passwordVerify,

                inviteToken: location.state?.token || null,
                website,
                captchaToken: captchaToken || undefined
            };
            await registerRequest(registerData);

            setAuthModalState('verify email');
        } catch (error) {
            if (error.response) {
                setErrorMessage(error.response.data.errorMessage);
            } else {
                setErrorMessage("An error occurred during registration.");
                console.error(error);
            }
        } finally {
            // Turnstile tokens are single-use; fetch a fresh one for the next attempt.
            setCaptchaResetKey((key) => key + 1);
        }
    }

    const handleClickLogInHere = () => {
        setErrorMessage("");
        setAuthModalState('login');
    }

    const handleClickContinueAsGuest = () => {
        setShowModal(false);
    }

    return (
        <div className={styles.container}>
            <img />
            <h1 className={styles.h1}>Create Your Account</h1>

             {/* Google Sign-In Button */}
             <GoogleSignInButton
                setErrorMessage={setErrorMessage}
                disableOneTap={true}
                setShowModal={setShowModal}
                setAcceptInvite={setAcceptInvite}
                acceptInvite={acceptInvite}
                buttonTextType="signup_with" 
             />

            {/* Divider */}
            <div className={styles.divider}>
                <span>OR</span>
            </div>

            <form onSubmit={register} className={styles.form}>
                <input
                    type="email"
                    placeholder="Email"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                    className={styles.input}
                />
                <input
                    placeholder="Username"
                    onChange={(e) => setUsername(e.target.value)}
                    value={username}
                    className={styles.input}
                />
                <input
                    type="password"
                    placeholder="Password"
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                    className={styles.input}
                />
                <input
                    type="password"
                    placeholder="Verify your password"
                    onChange={(e) => setPasswordVerify(e.target.value)}
                    value={passwordVerify}
                    className={styles.input}
                />
                <HoneypotField value={website} onChange={setWebsite} />
                <TurnstileWidget onToken={setCaptchaToken} resetKey={captchaResetKey} />
                {errorMessage && <div className={styles.error}> {errorMessage} </div>}
                <button className={styles.button} type="submit" disabled={TURNSTILE_ENABLED && !captchaToken}>SIGN UP</button>
            </form>
            <div className={styles.links}>
                Already have an account? <span className={styles.linkSpan} onClick={handleClickLogInHere}>Log In Here</span>
                {/* {!acceptInvite && (
                    <>
                        <br />
                        <span className={styles.orText}>OR</span>
                        <br />
                        <span className={styles.linkSpan} onClick={handleClickContinueAsGuest}>Continue as a guest</span>
                    </>
                )} */}
            </div>
        </div>
    );
}

export default Register;